import RecipeApi from '../api/mockRecipeApi';
import * as types from './actionTypes';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';

export function loadRecipeSuccess(recipe) {
	return {type: types.LOAD_RECIPE_SUCCESS, recipe: recipe};
}

export function loadRecipesSuccess(recipes) {
	return {type: types.LOAD_RECIPES_SUCCESS, recipes: recipes};
}

export function loadRecipe(recipe) {
	return dispatch => {
		dispatch(beginAjaxCall());
		return RecipeApi.loadRecipe(recipe).then(recipe => {
			dispatch(loadRecipeSuccess(recipe));
		}).catch(error => {
			throw(error);
		});
	};
}

export function loadRecipes(collection,filter,sort) {
	return dispatch => {
		dispatch(beginAjaxCall());
		return RecipeApi.loadRecipes(collection,filter,sort).then(recipes => {
			dispatch(loadRecipesSuccess(recipes));
		}).catch(error => {
			throw(error);
		});
	};
}


/** WEBPACK FOOTER **
 ** ./src/actions/recipeActions.js
 **/